<ng-container *transloco="let convert;">
  <div class="alerts-buyers">
    @if (users$ | async; as users) {
      <h2 tabindex="-1" #pageHeading aria-describedby="pageDescription" class="focus-outline-none">
      {{convert('profileManagement.alertBuyers.textUser')}}</h2>
      <p id="pageDescription"
        [innerHTML]="convert('profileManagement.alertBuyers.messagedeliverypreferences', {tenantShortName: tenantShortName})">
      </p>
      <app-legacy-table [columns]="columns" [data]="users" [tenantName]="tenantName$ | async" [cardConfig]="cardConfig"
        [caption]="convert('profileManagement.alertBuyers.captionBuyerSeller')">
        @for (row of users; track row) {
          <table-row-group>
            <table-row [columns]="columns" [row]="row">
              <table-cell *appTableCell="let row; column: 'name'" [attr.id]="'name_' + row.uuid + '_cell'">
                {{ row?.name }}
              </table-cell>
              <!-- <table-cell *appTableCell="let row; column: 'role'"> {{ row?.role }}</table-cell> -->
              <table-cell *appTableCell="let row; column: 'email'"> {{ row?.email }}</table-cell>
              <table-cell *appTableCell="let row; column: 'phone'">
                {{ row?.mobilePhone ? reformatPhone(row.mobilePhone) : '' }}
              </table-cell>
              <table-cell *appTableCell="let row; column: 'options'">
                <button data-track-elem="button" data-track-name="Manage" class="btn btn-link p-0 pb-1 pb-m-0"
                  (click)="openDrawer(drawer, row)"
                  [attr.aria-label]="convert('profileManagement.alertBuyers.ariaLabelManage') + row.name"
                  [attr.id]="'manage_' + row.uuid + '_button'">
                  {{convert('profileManagement.alertBuyers.labelManage')}}
                </button>
              </table-cell>
            </table-row>
            <table-row [ngClass]="drawer" [row]="row" [expandable]="true" [attr.id]="row.uuid + 'Drawer'"
              #drawer="table-row">
              <table-cell *appTableCell="let row; colSpan: columns.length">
                <div class="drawer-header">
                  @if (showError) {
                    <error-message></error-message>
                  }
                  @if (showSuccess) {
                    <success-message
                      [message]="convert('profileManagement.alertBuyers.textSuccessfullyUpdate') + currentRecipient.name + convert('profileManagement.alertBuyers.textSettingAlert')"
                    ></success-message>
                  }
                  <h3 class="manage-alerts-title focus-outline-none" tabindex="-1">
                  {{convert('profileManagement.alertBuyers.manageAlertsTitle')}}</h3>
                  <button data-track-elem="icon" data-track-name="Close" data-track-trigger="close"
                    class="btn btn-link drawer-header__close" (click)="cancel()"
                    [attr.aria-label]="convert('profileManagement.alertBuyers.ariaLabelCloseManage')">
                    <i class="allycon-glyph-close custom__dropdown--icon radiu_dropdown_icon text-primary"></i>
                  </button>
                </div>
                <table class="alert-settings__table">
                  <caption class="d-none">
                    {{convert('profileManagement.alertBuyers.tableCaptionSellerAlerts')}}
                  </caption>
                  <colgroup>
                  <col />
                  <col class="alert-settings__setting-value" />
                </colgroup>
                <thead>
                  <tr>
                    <th scope="col">{{convert('profileManagement.alertBuyers.tableHeaderAlertsWhen')}}</th>
                    <th class="text-center" scope="col">{{convert('profileManagement.alertBuyers.tableHeaderEmail')}}</th>
                  </tr>
                </thead>
                <tbody>
                  @if (buyAlerts$ | async; as buyAlerts) {
                    @for (alert of buyAlerts; track alert; let i = $index) {
                      <tr
                        [ngClass]="{ 'd-none': !checkVisibility(alert) }">
                        <td class="alert-settings__options">{{ getAlertDescription(alert) }}</td>
                        <td>
                          <div class="custom-control custom-checkbox">
                            <input type="checkbox" class="custom-control-input form-control" [id]="alert.type"
                              (change)="updateNotification($event, alert)" [checked]="checked(alert.type)"
                              [attr.aria-label]="getAlertDescription(alert)" />
                            <label [for]="alert.type" class="custom-control-label"> </label>
                          </div>
                        </td>
                      </tr>
                    }
                  }
                </tbody>
              </table>
              @if (showSellerAlerts) {
                <div class="drawer-header">
                  <h3 class="manage-alerts-title mt-3 focus-outline-none" tabindex="-1">
                  {{convert('profileManagement.alertBuyers.drawerAlertsHeader')}}</h3>
                </div>
                <table class="alert-settings__table">
                  <caption class="d-none">
                    {{convert('profileManagement.alertBuyers.tableCaptionSellerAlerts')}}
                  </caption>
                  <colgroup>
                  <col />
                  <col class="alert-settings__setting-value" />
                </colgroup>
                <thead>
                  <tr>
                    <th scope="col">{{convert('profileManagement.alertBuyers.tableHeaderAlertsWhen')}}</th>
                    <th scope="col">{{convert('profileManagement.alertBuyers.tableHeaderEmail')}}</th>
                  </tr>
                </thead>
                <tbody>
                  @if (sellAlerts$ | async; as sellAlerts) {
                    @for (alert of sellAlerts; track alert; let i = $index) {
                      <tr
                        [ngClass]="{ 'd-none': !checkVisibility(alert) }">
                        <td class="alert-settings__options">{{ getAlertDescription(alert) }}</td>
                        <td>
                          <div class="custom-control custom-checkbox">
                            <input type="checkbox" class="custom-control-input form-control" [id]="alert.type"
                              (change)="updateNotification($event, alert)" [checked]="checked(alert.type)"
                              [attr.aria-label]="getAlertDescription(alert)" />
                            <label [for]="alert.type" class="custom-control-label"> </label>
                          </div>
                        </td>
                      </tr>
                    }
                  }
                </tbody>
              </table>
            }
            <div class="manage-alerts__button-container mt-2">
              <button data-track-elem="button" data-track-name="Save" class="btn btn-primary" (click)="save()">
                {{convert('common.btnSave')}}
              </button>
              <button data-track-elem="button" data-track-name="Cancel"
                class="btn btn-secondary bid-buttons btn-outline-secondary" (click)="cancel()">
                {{convert('common.btnCancel')}}
              </button>
            </div>
          </table-cell>
        </table-row>
      </table-row-group>
    }
  </app-legacy-table>
}
</div>
<app-save-changes-modal (cancelEditing)="cancelEditing()" (continueEditing)="continueEditing()" [modalId]="modalId"
data-track-region="Buyers Alerts"></app-save-changes-modal>
</ng-container>